import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const IS_MOUNTED_DOMAIN_FOLDERS: boolean = isFeature('mounted-domain-folders');
